var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0979 1.85328C10.6967 0.0107522 13.3033 0.0107522 13.9021 1.85328L15.1435 5.67345C15.4113 6.49743 16.1791 7.05531 17.0455 7.05534L21.0623 7.0555C22.9997 7.05557 23.8052 9.53467 22.2379 10.6735L18.9883 13.0346C18.2874 13.5439 17.9941 14.4466 18.2618 15.2706L19.5029 19.0909C20.1015 20.9334 17.9927 22.4656 16.4253 21.3269L13.1755 18.966C12.4746 18.4568 11.5254 18.4568 10.8245 18.966L7.57473 21.3269C6.00732 22.4656 3.89847 20.9334 4.49708 19.0909L5.7382 15.2706C6.0059 14.4466 5.71261 13.5439 5.0117 13.0346L1.76211 10.6735C0.194793 9.53467 1.0003 7.05557 2.93767 7.0555L6.95449 7.05534C7.82088 7.05531 8.58874 6.49743 8.8565 5.67345L10.0979 1.85328Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.57ea5d45.svg";
export { ForwardRef as ReactComponent };